import { useState, useEffect } from 'react';
import { getPostsForSite, Post } from '../../lib/directus';

export const useRecentPosts = (limit: number = 5, domain: string) => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        setLoading(true);
        const allPosts = await getPostsForSite(domain);
        const recent = Array.isArray(allPosts) ? allPosts.slice(0, limit) : [];
        setPosts(recent);
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки последних постов:', err);
        setError('Не удалось загрузить последние посты');
      } finally {
        setLoading(false);
      }
    };
    fetchRecentPosts();
  }, [domain, limit]);

  return { posts, loading, error };
};